export enum SummaryCardEnum {
  TOTAL_LOYALTY_MEMBERS = 'TOTAL_LOYALTY_MEMBERS',
  TOTAL_LOYALTY_REVENUE = 'TOTAL_LOYALTY_REVENUE',
  TOTAL_REFERRALS = 'TOTAL_REFERRALS',
  PROMOS_ISSUED = 'PROMOS_ISSUED',
  CSAT_NPS_SCORE = 'CSAT_NPS_SCORE',
}

export enum experienceNumberOptions {
  BAD = 'bad',
  NEUTRAL = 'neutral',
  GOOD = 'good',
}
